import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });
export const adminApi = axios.create({ baseURL: API, withCredentials: true });

const STUDENT_KEY = "smartguru_student_id";
const NARRATION_VOICE_KEY = "smartguru_narration_voice";
const GOOGLE_PENDING_KEY = "smartguru_google_pending";

export const getStudentId = () => localStorage.getItem(STUDENT_KEY);
export const setStudentId = (id) => localStorage.setItem(STUDENT_KEY, id);
export const clearStudentId = () => localStorage.removeItem(STUDENT_KEY);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const goToGoogleLogin = (pending = {}) => {
  sessionStorage.setItem(GOOGLE_PENDING_KEY, JSON.stringify(pending));
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const getGooglePending = () => {
  try {
    return JSON.parse(sessionStorage.getItem(GOOGLE_PENDING_KEY) || "{}");
  } catch {
    return {};
  }
};

export const clearGooglePending = () => sessionStorage.removeItem(GOOGLE_PENDING_KEY);

export const NARRATION_VOICE_PARAMS = {
  en_standard: { label: "English (Classic)" },
  en_riya: { label: "English (Riya)" },
  hi_mixed: { label: "Hindi (Mixed)" },
};

export const getNarrationVoice = () => localStorage.getItem(NARRATION_VOICE_KEY) || "en_riya";
export const setNarrationVoice = (v) => localStorage.setItem(NARRATION_VOICE_KEY, v);
export const getNarrationVoiceParams = () => NARRATION_VOICE_PARAMS[getNarrationVoice()] || NARRATION_VOICE_PARAMS.en_riya;
